import EventDTO, { EventPublicStatus } from '../models/event';

const dummyEvent = (businessName: string): EventDTO => ({
  id: '1',
  business_id: '1',
  name: 'Degustación de Avantti',
  description: 'Degustación de Avantti',
  date: '2021-01-01',
  ends_at: '2021-01-01',
  place: 'Lugar del evento',
  active: true,
  terms: 'Términos y condiciones del evento',
  phone: '1234567890',
  tickets: [],
  banner_image: '/Event-Picture.png',
  maps_link: 'https://maps.google.com',
  allow_mercadopago_payments: true,
  allow_payway_payments: true,
  allow_uala_payments: true,
  allow_nave_payments: true,
  allow_zilo_payments: true,
  allow_manual_payments: true,
  allow_in_person_sales: true,
  online_service_charge: 0,
  manual_service_charge: 0,
  min_age: 0,
  address: 'Dirección de la productora',
  require_id_tickets: false,
  custom_ticket_label: null,
  receives_wire_transfers: true,
  has_polls: true,
  is_public: true,
  has_numerated_seats: true,
  tickets_includes_service_charge: true,
  has_seller_qr: true,
  has_scanner_auto_accept: true,
  has_order_qrs: true,
  is_important: true,
  is_approved: true,
  public_display: true,
  banner_display: true,
  public_status: EventPublicStatus.Ready,
  seller_sales_enabled: true,
  slug: 'productora-de-prueba',
  seller_can_download_tickets: true,
  created_at: '2021-01-01',
  updated_at: '2021-01-01',
  has_audience_discounts: true,
  has_open_price: true,
  has_simplified_selling: true,
  has_showtimes: false,
  has_subscription: false,
  notify_purchases: true,
  is_sold_out: false,
  business_name: businessName,
  superfast_checkout: false,
  has_order_referrals: 'disabled',
  show_sellers_ranking: true,
  meta_pixel_id: null,
  absorbed_service_charge_rate: 0,
  online_comission_rate: 0,
  has_lists: true,
  list: {
    id: '1',
    name: 'Lista de invitados',
    description: 'Lista de invitados',
    date: '2021-01-01',
    active: true,
    user_id: '1',
    event_id: '1',
    created_at: '2021-01-01',
    updated_at: '2021-01-01',
  },
  order_phone_number: true,
  coproducer_reports: false,
  coproducer_balance: false,
});

export default dummyEvent;
